export const selectScenes = (state) => state.scenes.scenes.items;

export const selectScenesCounts = (state) => state.scenes.counts;
